var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10138 7.99967L12.8402 4.26065C12.9431 4.15772 12.9998 4.02041 13 3.87398C13 3.72748 12.9433 3.59 12.8402 3.48724L12.5126 3.15967C12.4096 3.0565 12.2723 3 12.1257 3C11.9793 3 11.842 3.0565 11.739 3.15967L8.00016 6.89845L4.26114 3.15967C4.15829 3.0565 4.02089 3 3.87439 3C3.72805 3 3.59065 3.0565 3.4878 3.15967L3.16 3.48724C2.94667 3.70057 2.94667 4.04756 3.16 4.26065L6.89894 7.99967L3.16 11.7385C3.05707 11.8416 3.00041 11.9789 3.00041 12.1254C3.00041 12.2718 3.05707 12.4091 3.16 12.5121L3.48772 12.8397C3.59057 12.9428 3.72805 12.9993 3.87431 12.9993C4.02081 12.9993 4.15821 12.9428 4.26106 12.8397L8.00008 9.10081L11.7389 12.8397C11.842 12.9428 11.9793 12.9993 12.1256 12.9993H12.1258C12.2722 12.9993 12.4095 12.9428 12.5125 12.8397L12.8402 12.5121C12.943 12.4092 12.9998 12.2718 12.9998 12.1254C12.9998 11.9789 12.943 11.8416 12.8402 11.7386L9.10138 7.99967Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.31fa7964aff671ffa0e6a4a750dfd1fc.svg";
export { ForwardRef as ReactComponent };